<template>
        <el-drawer title="编辑座位号字段" :visible.sync="updateVisible" :before-close="closeDialog" size="400px">
            <div class="drawer-content">
                <el-form :model="form" label-position="top" ref="updateForm" :rules="rules">                 
                                          
                    <el-form-item label="关键字名称" prop="name">
                        <el-input v-model="form.name" autocomplete="off" maxlength="40" placeholder="请输入关键字名称" size="medium"></el-input>
                    </el-form-item> 
					<el-form-item label="打印顺序" prop="number">
					    <el-input v-model="form.number" autocomplete="off" maxlength="40" placeholder="请输入打印顺序" size="medium" disabled></el-input>
					</el-form-item> 
                    
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
            </div>
        </el-drawer>
</template>

<script>
const defaultData = {   
    name: '', // 关键字名称
    number: '', // 排序
}
export default {
    props: {
    },
    data(){
       
        return {
            form: {...defaultData},           
            submitLoading: false,            
            rules: {               
                name:  [
                    { required: true, message: '请输入关键字名称', trigger: 'blur' }
                ]                
            },
            updateVisible: false
        }
    },
    created(){
        
    },
    
    methods: {
        show(data){
            if( data ){
                const n = {...data};
               
                this.form = {...n};
               
            }
            
            this.updateVisible = true;
        },
        submitForm(){
            this.$refs['updateForm'].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                          
                    this.$request({
                        url:'/ticketSeatNumber/update',
                        method: "POST",
                        params: {
							name:this.form.name,
							number:this.form.number
                       },
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('修改成功');
							this.$emit('onUpdate');
                            this.closeDialog();
                            
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            });
        },
       
        closeDialog(){           
            this.form = {...defaultData};            
            this.updateVisible = false;            
        }
    }
}
</script>

<style lang="scss" scoped>
.terminal{
    ::v-deep .el-form-item__content{
        line-height: 34px;
    }
}
.has-tips {
    ::v-deep .el-form-item__label{
        width: 100%;
        display: flex;
        align-items: center;

        & > * {
            flex: 0 0 auto;
        }
        .tips{
            flex: 1 1 auto;
            margin-left: 10px;
            font-size: 12px;
            overflow: hidden;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }    
}
</style>